import script from "./BarChartCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BarChartCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__